/**
 * Mirror of LFM\Lfmpublications\Domain\Enum\PublicationType.
 *
 * PHP is the source of truth for these uids (they match tblTyp.csv); this file only
 * puts names on them so the form doesn't compare against bare integers. Keep both
 * sides in sync when a type is added.
 *
 * Form state carries the type as a number or a string depending on where it came
 * from, so compare loosely (`==`) in templates or coerce with Number() in script.
 */
export const PublicationType = Object.freeze({
    Monographie: 1,
    Sammelwerksbeitrag: 2,
    Zeitschriftenaufsatz: 3,
    Sammelwerk: 4,
});

/**
 * Uids from tx_lfmpublications_domain_model_mediatype. Not an enum on the PHP side —
 * these are editable records, so only pin down the ones the form has to reason about.
 */
export const MediaType = Object.freeze({
    Online: 2,
});
